import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgEMail = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M36 10H4v13h32z"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m4 10 16 10 16-10v20H4z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m8.265 14.576-.53.848L16 20.59l16.265-10.166-.53-.848L16 19.41z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgEMail);

export default ForwardRef;
